// extracted by mini-css-extract-plugin
export default {"Pagination":"_x_aVGoW820XzspPveWn","Controls":"qHGcfLsY9OMLGvRHkcz9","SizeSelect":"wzXwJmXGaCHG2dMko5kJ","PageButton":"Uz9IBZn86j3l2HEYyOED","PageNumber":"KKvIRxJONEa0ncqEmY1A"};